import {observer} from "mobx-react";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import React from "react";
import {USSafeToPlayComponent} from "./safe-to-play/us.safe-to-play.component";
import {USResponsibleGamingButtonsBox} from "./boxes/us.responsible-gaming-buttons.box";
import {USResponsibleGamingComponent} from "./responsible-gaming/us.responsible-gaming.component";

export const USResponsibleGamingButtonsComponent = observer(class DenmarkResponsibleGamingButtonsComponent extends OrbitComponent {
    render() {
        const usFlag = this.services.configuration.data.header.responsibleIcons.usFlag;
        return (
            <USResponsibleGamingButtonsBox>
                {usFlag && usFlag.display && <USSafeToPlayComponent/>}
                <USResponsibleGamingComponent/>
            </USResponsibleGamingButtonsBox>
        );
    }
});